/* @generated */

// ../src/snackbar/snackbar.tsx
import classNames from "classnames";
import * as React7 from "react";

// ../src/snackbar/position.tsx
import * as React from "react";
import cx from "classnames";
import { Overlay } from "@dropbox/dig-components/overlay";
import { Layer, ELEVATED_BASE_INDEX } from "@dropbox/dig-components/layer";

// ../src/snackbar/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var accessory = "dig-1srtvqa3_22-5-0";
var actions = "dig-1srtvqa8_22-5-0";
var content = "dig-1srtvqa5_22-5-0";
var message = "dig-1srtvqa2_22-5-0";
var position = _7a468({ defaultClassName: "dig-1srtvqa6_22-5-0", variantClassNames: { fullScreen: { true: "dig-1srtvqa7_22-5-0" } }, defaultVariants: { fullScreen: false }, compoundVariants: [] });
var progressBar = "dig-1srtvqa4_22-5-0";
var snackbar = _7a468({ defaultClassName: "dig-1srtvqa0_22-5-0", variantClassNames: { preferComposition: { true: "dig-1srtvqa1_22-5-0" } }, defaultVariants: { preferComposition: false }, compoundVariants: [] });

// ../src/snackbar/position.tsx
var Position = React.forwardRef(
  ({ children, anchorRef, isVisibleOnScroll = false, boundaryRef }, ref) => {
    const overlayRef = React.useRef(null);
    React.useImperativeHandle(
      ref,
      () => ({
        update: () => {
          var _a;
          (_a = overlayRef.current) == null ? void 0 : _a.update();
        }
      }),
      [overlayRef]
    );
    return anchorRef ? /* @__PURE__ */ React.createElement(
      Overlay,
      {
        ref: overlayRef,
        anchorRef,
        placement: "bottom-start",
        setWidthSameAsAnchor: true,
        isVisibleOnScroll,
        boundaryRef
      },
      /* @__PURE__ */ React.createElement("div", { className: cx("dig-Snackbar-position", position({})) }, children)
    ) : /* @__PURE__ */ React.createElement(Layer, { _elevateByZ: ELEVATED_BASE_INDEX }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(
          "dig-Snackbar-position",
          "dig-Snackbar-position--full-screen",
          position({ fullScreen: true })
        )
      },
      children
    ));
  }
);
Position.displayName = "Snackbar.Position";

// ../src/snackbar/actions.tsx
import * as React2 from "react";
import cx2 from "classnames";
var Actions = ({ className = "", children, ...rest }) => {
  return /* @__PURE__ */ React2.createElement("div", { className: cx2("dig-Snackbar-actions", actions, className), ...rest }, children);
};
Actions.displayName = "Snackbar.Actions";

// ../src/snackbar/message.tsx
import * as React3 from "react";
import cx3 from "classnames";
import { Text } from "@dropbox/dig-components/typography";
var Message = ({ className = "", children, ...rest }) => {
  return /* @__PURE__ */ React3.createElement(
    Text,
    {
      className: cx3("dig-Snackbar-message", message, className),
      ...rest,
      color: "inherit",
      tagName: "span"
    },
    children
  );
};
Message.displayName = "Snackbar.Message";

// ../src/snackbar/progress_bar.tsx
import * as React4 from "react";
import cx4 from "classnames";
var ProgressBar = ({ children }) => {
  return /* @__PURE__ */ React4.createElement("div", { className: cx4("dig-Snackbar-progress-bar", progressBar) }, children);
};
ProgressBar.displayName = "Snackbar.ProgressBar";

// ../src/snackbar/accessory.tsx
import * as React5 from "react";
import cx5 from "classnames";
var Accessory = ({ children }) => {
  return /* @__PURE__ */ React5.createElement("div", { className: cx5("dig-Snackbar-accessory", accessory) }, children);
};
Accessory.displayName = "Snackbar.Accessory";

// ../src/snackbar/content.tsx
import * as React6 from "react";
import cx6 from "classnames";
var Content = ({ children }) => {
  return /* @__PURE__ */ React6.createElement("div", { className: cx6("dig-Snackbar-content", content) }, children);
};
Content.displayName = "Snackbar.Content";

// ../src/snackbar/snackbar.tsx
import { useTheme } from "@dropbox/dig-foundations";
import {
  EASE_ENTER,
  EASE_LEAVE,
  useMotion
} from "@dropbox/dig-components/motion";
var getSnackbarMotion = () => {
  return /* @__PURE__ */ new Map([
    [
      "open",
      {
        keyFrames: {
          transform: ["translate(0, 10px)", "translate(0,0)"],
          opacity: [0, 1]
        },
        options: {
          duration: 0.125,
          ease: EASE_ENTER
        }
      }
    ],
    [
      "close",
      {
        keyFrames: {
          opacity: [1, 0]
        },
        options: {
          duration: 0.125,
          ease: EASE_LEAVE
        }
      }
    ]
  ]);
};
var Snackbar = ({
  className,
  children,
  onRequestClose,
  open,
  timeout = 8e3,
  preferComposition = false,
  ...rest
}) => {
  const { getInverseProps } = useTheme();
  const cls = classNames(
    className,
    "dig-Snackbar",
    snackbar({ preferComposition }),
    getInverseProps().className,
    {
      "dig-Snackbar--preferComposition": preferComposition
    }
  );
  React7.useEffect(() => {
    if (timeout > 0) {
      let id = null;
      if (open) {
        if (onRequestClose) {
          id = window.setTimeout(onRequestClose, timeout);
          return () => {
            if (id) clearTimeout(id);
          };
        }
      } else if (id) {
        clearTimeout(id);
      }
    }
  }, [onRequestClose, open, timeout]);
  const animationStates = React7.useMemo(() => getSnackbarMotion(), []);
  const motionRef = React7.useRef(null);
  const { isMotionRunning } = useMotion({
    states: animationStates,
    currentState: open ? "open" : "close",
    elementRef: motionRef
  });
  return open || isMotionRunning ? /* @__PURE__ */ React7.createElement("div", { ref: motionRef, className: cls, role: "alert", ...rest }, children) : null;
};
Snackbar.displayName = "Snackbar";
Snackbar.Actions = Actions;
Snackbar.Message = Message;
Snackbar.ProgressBar = ProgressBar;
Snackbar.Position = Position;
Snackbar.Accessory = Accessory;
Snackbar.Content = Content;
export {
  Snackbar
};
